
    <button [type]="type" [class.--loading]="loading" [disabled]="disabled">
      <!-- [style.background-image]="cssBackground" -->
      <span *ngIf="icon && iconPosition === 'left'" class="icon-left"><i [class]="icon"></i></span>
      <ng-content></ng-content>
      <span *ngIf="icon && iconPosition === 'right'" class="icon-right"><i [class]="icon"></i></span>
    </button>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/buttons/form-button.component.ts.FormButtonComponent.html